function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.097656 5.222656 L 3.972656 8.347656 C 3.847656 8.46875 3.652344 8.46875 3.527344 8.347656 C 3.40625 8.222656 3.40625 8.027344 3.527344 7.902344 L 6.433594 5 L 3.527344 2.097656 C 3.40625 1.972656 3.40625 1.777344 3.527344 1.652344 C 3.652344 1.53125 3.847656 1.53125 3.972656 1.652344 L 7.097656 4.777344 C 7.15625 4.835938 7.1875 4.917969 7.1875 5 C 7.1875 5.082031 7.15625 5.164062 7.097656 5.222656 Z M 7.097656 5.222656 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightWhite);
export default __webpack_public_path__ + "static/media/caret_right_white.fad7ea5931e96c482d983ecd38899cb6.svg";
export { ForwardRef as ReactComponent };